import { render } from "./ChangeAccountDialog.vue?vue&type=template&id=6c9b9d9e&scoped=true&ts=true"
import script from "./ChangeAccountDialog.vue?vue&type=script&lang=ts"
export * from "./ChangeAccountDialog.vue?vue&type=script&lang=ts"

import "./ChangeAccountDialog.vue?vue&type=style&index=0&id=6c9b9d9e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9b9d9e"]])

export default __exports__